import React, { useEffect, useState } from "react";
import { Steps } from 'primereact/steps';
import { Checkbox } from "primereact/checkbox";
import PaymentForm from "./creditCard";
import './creditCardStyles.css';
import './signupFlowStyles.css';
import { Dropdown } from "primereact/dropdown";
import { wglcsApiService } from "../../../services/WglcsApiService";
import { InputText } from "primereact/inputtext";
import { useNavigate, useLocation } from "react-router-dom";
import { Skeleton } from "primereact/skeleton";
import { DetectEnvironment } from "../../../EnvironmentSettings";

const BillingInformation = (props) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [isAggreed, setIsAggreed] = useState<boolean>(false);
    const [isContact, setIsContact] = useState<boolean>(false);
    const [countryLoader, setCountryLoader] = useState<boolean>(false);
    const [stateLoader, setStateLoader] = useState<boolean>(false);
    const [isCardInValid, setIsCardInValid] = useState<boolean>(true);
    const [cityLoader, setCityLoader] = useState<boolean>(false);
    const [companyName, setCompanyName] = useState<string>('');
    const [companyNameError, setCompanyNameError] = useState<string>('');
    const [nameOnCard, setNameOnCard] = useState<string>('');
    const [cardNumber, setCardNumber] = useState<string>('');
    const [totalAmount, setTotalAmount] = useState<string | number>('');
    const [cardExpiry, setCardExpiry] = useState<string>('');
    const [cvc, setCvc] = useState<string>('');
    const [companyNameB, setCompanyNameB] = useState<string>('');
    const [companyNameErrorB, setCompanyNameBErrorB] = useState<string>('');
    const [contactPerson, setContactPerson] = useState<string>('');
    const [cardErrorMsg, setCardErrorMsg] = useState<string>('');
    const [contactPersonError, setContactPersonError] = useState<string>('');
    const [contactPersonB, setContactPersonB] = useState<string>('');
    const [contactPersonBError, setContactPersonBError] = useState<string>('');
    const [designation, setDesignation] = useState<string>('');
    const [designationErrror, setDesignationError] = useState<string>('');
    const [designationB, setDesignationB] = useState<string>('');
    const [designationBError, setDesignationBError] = useState<string>('');
    const [contactAddress, setContactAddress] = useState<string>('');
    const [contactAddressError, setContactAddressError] = useState<string>('');
    const [contactAddressB, setContactAddressB] = useState<string>('');
    const [contactAddressBError, setContactAddressBError] = useState<string>('');
    const [selectedCountry, setSelectedCountry] = useState<string>('');
    const [selectedCountryError, setSelectedCountryError] = useState<string>('');
    const [selectedCountryB, setSelectedCountryB] = useState<string>('');
    const [selectedCountryBError, setSelectedCountryBError] = useState<string>('');
    const [selectedState, setSelectedState] = useState<string>('');
    const [selectedStateError, setSelectedStateError] = useState<string>('');
    const [selectedStateB, setSelectedStateB] = useState<string>('');
    const [selectedStateBError, setSelectedStateBError] = useState<string>('');
    const [selectedCity, setSelectedCity] = useState<string>('');
    const [selectedCityError, setSelectedCityError] = useState<string>('');
    const [selectedCityB, setSelectedCityB] = useState<string>('');
    const [selectedCityBError, setSelectedCityBError] = useState<string>('');
    const [postalCode, setPostalCode] = useState<string>('');
    const [postalCodeError, setPostalCodeError] = useState<string>('');
    const [postalCodeB, setPostalCodeB] = useState<string>('');
    const [postalCodeBError, setPostalCodeBError] = useState<string>('');
    const [refresh, setRefresh] = useState<any>('');
    const [phone, setPhone] = useState<string>('');
    const [phoneError, setPhoneError] = useState<string>('');
    const [phoneB, setPhoneB] = useState<string>('');
    const [phoneBError, setPhoneBError] = useState<string>('');
    const [deploymentContractDetailId, setDeploymentContractDetailId] = useState<number>();
    const [email, setEmail] = useState<string>('');
    const [emailError, setEmailError] = useState<string>('');
    const [emailB, setEmailB] = useState<string>('');
    const [emailBError, setEmailBError] = useState<string>('');
    const [countries, setCountries] = useState<any[]>([]);
    const [addOns, setAddOns] = useState<any[]>([]);
    const [states, setStates] = useState<any[]>([]);
    const [cities, setCities] = useState<any[]>([]);
    const [selectedAddons, setSelectedAddons] = useState<any[]>([]);
    const navigate = useNavigate();
    const skeletonLength = Array.from({ length: 7 }, (_, index) => index);
    const location = useLocation();
    const { signUpData } = location.state || {};

    const items = [
        {
            label: 'Contact Information',
        },
        {
            label: 'Billing Information',
        },
        {
            label: 'Order Summary',
        }
    ];

    useEffect(() => {
        if (activeIndex === 1) {
            if (!contactValidations()) {
                setActiveIndex(0);
            }
        }
        if (activeIndex === 2) {
            if (!billingValidations()) {
                setActiveIndex(1);
            }
        }
    }, [activeIndex]);

    useEffect(() => {
        setCompanyName(signUpData?.companyName)
        setContactPerson(signUpData?.contactPerson)
        setEmail(signUpData?.email)
        setPhone(signUpData?.phone)
        setDeploymentContractDetailId(signUpData?.deploymentContractDetailId)
        getCountries();
        getAddOns();
    }, [])

    const getCountries = async () => {
        setCountryLoader(true);
        let response = await wglcsApiService.getallcountries();
        setCountries(response?.data?.data)
        setCountryLoader(false);
    }

    const getAddOns = async () => {
        let response = await wglcsApiService.getavailableaddons();
        const filteredAddOns = response?.data?.data?.map(addOn => {
            return {
                ...addOn, // Keep the other keys and values intact
                price: addOn?.price === null ? 0 : addOn.price, // Set price to 0 if null
                setUpPrice: addOn?.setUpPrice === null ? 0 : addOn.price // Set price to 0 if null
            };
        });
        setAddOns(filteredAddOns)
        // setAddOns(response?.data?.data)
    }

    const onChageCountries = async (e) => {
        setSelectedCountry(e?.target?.value)
        setSelectedCountryError('')
        setStateLoader(true);
        let stateResponse = await wglcsApiService.getstatesbycountryid(e?.target?.value)
        setStates(stateResponse?.data.data);
        setStateLoader(false);
    }

    const onChageCountriesB = async (e) => {
        setSelectedCountryB(e?.target?.value)
        setSelectedCountryBError('')
        setStateLoader(true);
        let stateResponse = await wglcsApiService.getstatesbycountryid(e?.target?.value)
        setStates(stateResponse?.data.data);
        setStateLoader(false);
    }

    const onChangeStates = async (e) => {
        setSelectedState(e.target.value);
        setCityLoader(true);
        setSelectedStateError('');
        let cityResponse = await wglcsApiService.getcitiesbystateid(e.target.value)
        setCities(cityResponse?.data.data);
        setCityLoader(false);
    }
    const stateItemTemplate = (option) => {
        if (stateLoader) {
            return (
                <div style={{ marginTop: '15px' }}>
                    <Skeleton style={{ marginTop: 10 }} ></Skeleton>
                </div>
            );
        }
        if (option) {
            return (
                <div>{option.stateName}</div>
            );
        }
    };
    const countryItemTemplate = (option) => {
        if (countryLoader) {
            return (
                <div style={{ marginTop: '15px' }}>
                    <Skeleton style={{ marginTop: 10 }} ></Skeleton>
                </div>
            );
        }
        if (option) {
            return (
                <div>{option.countryName}</div>
            );
        }
    };
    const cityItemTemplate = (option) => {
        if (cityLoader) {
            return (
                <div style={{ marginTop: '15px' }}>
                    <Skeleton style={{ marginTop: 10 }} ></Skeleton>
                </div>
            );
        }
        if (option) {
            return (
                <div>{option.cityName}</div>
            );
        }
    };

    const onChangeStatesB = async (e) => {
        setSelectedStateB(e.target.value);
        setSelectedStateBError('');
        setCityLoader(true);
        let cityResponse = await wglcsApiService.getcitiesbystateid(e.target.value)
        setCities(cityResponse?.data.data);
        setCityLoader(false);
    }

    const onChangeUseInfo = async (e) => {
        setIsContact(e.checked)
        if (e.checked == true) {
            setContactAddressB(contactAddress);
            setContactAddressBError('');
            setCompanyNameB(companyName);
            setCompanyNameBErrorB('');
            setContactPersonB(contactPerson);
            setContactPersonBError('');
            setDesignationB(designation);
            setDesignationBError('');
            setSelectedCountryB(selectedCountry);
            setSelectedCountryBError('');
            setSelectedStateB(selectedState);
            setSelectedStateBError('');
            setSelectedCityB(selectedCity);
            setSelectedCityBError('');
            setPostalCodeB(postalCode);
            setPostalCodeBError('');
            setPhoneB(phone);
            setPhoneBError('');
            setEmailB(email);
            setEmailBError('');
        } else {
            setContactAddressB('');
            setCompanyNameB('');
            setContactPersonB('');
            setDesignationB('');
            setSelectedCountryB('');
            setSelectedStateB('');
            setSelectedCityB('');
            setPostalCodeB('');
            setPhoneB('');
            setEmailB('');
        }
    }

    const validateEmail = (email) => {
        const re =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    };

    const contactValidations = () => {
        let isFormValid = true;
        if (companyName?.trim() == '') {
            setCompanyNameError('*Required')
            isFormValid = false;
        }
        if (contactPerson?.trim() == '') {
            setContactPersonError('*Required')
            isFormValid = false;
        }
        if (designation?.trim() == '') {
            setDesignationError('*Required')
            isFormValid = false;
        }

        if (contactAddress?.trim() == '') {
            setContactAddressError('*Required')
            isFormValid = false;
        }
        if (email?.trim() == '') {
            setEmailError('*Required')
            isFormValid = false;
        }
        if (validateEmail(email) == false) {
            setEmailError("*Email Address is not valid")
            isFormValid = false;
        }
        if (phone?.trim() == '') {
            setPhoneError('*Required')
            isFormValid = false;
        }
        if (selectedCountry == '') {
            setSelectedCountryError("*Required")
            isFormValid = false;
        }
        if (selectedState == '') {
            setSelectedStateError("*Required")
            isFormValid = false;
        }
        if (selectedCity == '') {
            setSelectedCityError("*Required")
            isFormValid = false;
        }
        if (postalCode?.trim() == '') {
            setPostalCodeError("*Required")
            isFormValid = false;
        }
        return isFormValid;
    }

    const ChildValidations = (e) => {
        setIsCardInValid(e)
    }

    const nameHandle = (e) => {
        setCardErrorMsg('')
        setNameOnCard(e)
    }

    const billingValidations = () => {

        let isFormValid = true;
        if (companyNameB?.trim() == '') {
            setCompanyNameBErrorB('*Required')
            isFormValid = false;
        }
        if (contactPersonB?.trim() == '') {
            setContactPersonBError('*Required')
            isFormValid = false;
        }
        if (designationB?.trim() == '') {
            setDesignationBError('*Required')
            isFormValid = false;
        }
        if (contactAddressB?.trim() == '') {
            setContactAddressBError('*Required')
            isFormValid = false;
        }
        if (emailB?.trim() == '') {
            setEmailBError('*Required')
            isFormValid = false;
        }
        if (validateEmail(emailB) == false) {
            setEmailBError("*Please Enter a valid email address")
            isFormValid = false;
        }
        if (phoneB?.trim() == '') {
            setPhoneBError('*Required')
            isFormValid = false;
        }
        if (selectedCountryB == '') {
            setSelectedCountryBError("*Required")
            isFormValid = false;
        }
        if (selectedStateB == '') {
            setSelectedStateBError("*Required")
            isFormValid = false;
        }
        if (selectedCityB == '') {
            setSelectedCityBError("*Required")
            isFormValid = false;
        }
        if (postalCodeB?.trim() == '') {
            setPostalCodeBError("*Required")
            isFormValid = false;
        }
        if (isCardInValid == true) {
            isFormValid = false;
            setCardErrorMsg("*Make sure you have completed the card's valid info")
        }
        return isFormValid;
    }

    const onNextContact = () => {
        if (contactValidations()) {
            setActiveIndex(1)
        }
    }

    const onNextBilling = () => {
        if (billingValidations()) {
            setActiveIndex(2)
        }
    }

    const CheckOut = () => {

        const selectedAdons = selectedAddons?.map(e => e.addOneId)
        const cardNumberWithSpaces = cardNumber;
        const cardNumberWithoutSpaces = parseInt(cardNumberWithSpaces.replace(/\s/g, ''), 10);
        let expiryModified = cardExpiry.replace('/', '')
        let payload = {
            packageId: 4,
            deploymentContractDetailId: deploymentContractDetailId,
            contactInfo: {
                companyName: companyName,
                contactPerson: contactPerson,
                designation: designation,
                address: contactAddress,
                countryId: selectedCountry,
                stateId: selectedState,
                cityId: selectedCity,
                zipCode: postalCode,
                phone: phone,
                email: email
            },
            billingInfo: {
                companyName: companyNameB,
                contactPerson: contactPersonB,
                designation: designationB,
                address: contactAddressB,
                countryId: selectedCountryB,
                stateId: selectedStateB,
                cityId: selectedCityB,
                zipCode: postalCodeB,
                phone: phoneB,
                email: emailB
            },
            cardInfo: {
                name: nameOnCard,
                number: cardNumberWithoutSpaces.toString(),
                expiry: expiryModified,
                cvv: parseInt(cvc)
                // cvv: cvc
            },
            addonIds: selectedAdons
        }
        checkOutApi(payload);

    }
    const checkOutApi = async (payload) => {
        try {
            // Attempt to send the payload to the backend
            let response = await wglcsApiService.processpackagesignup(payload);

            // Optionally check if the response is successful, e.g., response.status === 200
            if (response.status === 200) {
                console.log('Transaction successful');
            } else {
                console.error('Unexpected response:', response);
            }

            // Navigate to the completed transaction page even after a response
            navigate('/transection-completed', { state: { totalAmount: totalAmount } });
        } catch (error) {
            // Catch any errors including 500 server errors
            console.error('Error occurred during checkout:', error);

            // Navigate to the completed transaction page even in case of error
            navigate('/transection-completed', { state: { totalAmount: totalAmount, error: 'Something went wrong, but you are redirected.' } });
        }
    }

    const onClickAdd = (e) => {

        selectedAddons.push(e);
        let totalPrice = 0;
        for (const obj of selectedAddons) {
            if (obj.setUpPrice !== null && !isNaN(obj.setUpPrice)) {
                totalPrice += obj.setUpPrice;
            }
        }
        setTotalAmount(totalPrice);
        setSelectedAddons(selectedAddons);
        setRefresh(refresh + selectedAddons + new Date().getTime() + '' + selectedAddons)
    }

    const isAddDisable = (e) => {
        const isIdExists = selectedAddons.some(x => x.addOneId == e?.addOneId)
        return isIdExists;
    }
    const onClickRemove = (e) => {
        const filteredItems = selectedAddons.filter(x => x.addOneId !== e?.addOneId)
        let totalPrice = 0;
        for (const obj of filteredItems) {
            if (obj.setUpPrice !== null && !isNaN(obj.setUpPrice)) {
                totalPrice += obj.setUpPrice;
            }
        }
        setTotalAmount(totalPrice);
        setSelectedAddons(filteredItems)
    }

    const onClickStepper = (e) => {

        let currentIndex = e?.index
        if (currentIndex == 1 && contactValidations()) {
            setActiveIndex(e.index)
        }
        if (currentIndex == 2 && billingValidations()) {
            setActiveIndex(e.index)
        }
        // setActiveIndex(e.index)
    }


    return (
        <div className="billling-screen billing-wrapper">
            {activeIndex == 0 &&
                <>
                    <div className="welcome-wrapper">
                        <div className="row m-0" >
                            <div className="col-lg-9 ">
                                <img className="welcome-page-logo" src={process.env.PUBLIC_URL + "/image/" + DetectEnvironment.config.REACT_APP_LOGO} alt="logo" />
                                <div className="row justify-content-lg-center billing-pad ">
                                    <div className="col-lg-9">
                                        <div className="steps">
                                            <Steps model={items} activeIndex={activeIndex} onSelect={(e) => onClickStepper(e)} readOnly={false} />
                                        </div>
                                        <div className="signup-form-wrapper">
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="la-heading">
                                                        Contact Information
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <span className="signup-icon">
                                                        <i className="fa-light fa-building"></i>
                                                        <input value={companyName} onChange={(e) => { setCompanyNameError(''); setCompanyName(e.target.value) }} className="signup-input" placeholder="Company Name" />
                                                        <span className="error-text">{companyNameError}</span>
                                                    </span>
                                                </div>
                                                <div className="col-lg-6">
                                                    <span className="signup-icon">
                                                        <i className="fa-light fa-user-circle"></i>
                                                        <input value={contactPerson} onChange={(e) => { setContactPersonError(''); setContactPerson(e.target.value) }} className="signup-input" placeholder="Contact Person" />
                                                        <span className="error-text">{contactPersonError}</span>
                                                    </span>
                                                </div>

                                                <div className="col-lg-6">
                                                    <span className="signup-icon">
                                                        <i className="fa-light fa-user-circle"></i>
                                                        <input value={designation} onChange={(e) => { setDesignationError(''); setDesignation(e.target.value) }} className="signup-input" placeholder="Title Designation" />
                                                        <span className="error-text">{designationErrror}</span>
                                                    </span>
                                                </div>
                                                <div className="col-lg-6">
                                                    <span className="signup-icon">
                                                        <i className="fa-light fa-address-card"></i>
                                                        <input value={contactAddress} onChange={(e) => { setContactAddressError(''); setContactAddress(e.target.value) }} className="signup-input" placeholder="Address" />
                                                        <span className="error-text">{contactAddressError}</span>
                                                    </span>
                                                </div>
                                                <div className="col-lg-6">
                                                    <span className="signup-icon">
                                                        <i className="fa-light fa-globe"></i>
                                                        {/* <input value={selec} onChange={(e) => setCompanyName(e.target.value)} className="signup-input" placeholder="Country" /> */}
                                                        <Dropdown
                                                            className='signup-input'
                                                            filter
                                                            showFilterClear
                                                            value={selectedCountry}
                                                            options={countryLoader == true ? skeletonLength : countries}
                                                            onChange={(e) => onChageCountries(e)}
                                                            itemTemplate={countryItemTemplate}
                                                            optionLabel="countryName"
                                                            optionValue="countryId"
                                                            placeholder="Country"
                                                        />
                                                        <span className="error-text">{selectedCountryError}</span>
                                                    </span>
                                                </div>

                                                <div className="col-lg-6">
                                                    <span className="signup-icon">
                                                        <i className="fa-light fa-flag-usa"></i>
                                                        {/* <input className="signup-input" placeholder="State/Province" /> */}
                                                        <Dropdown
                                                            className='signup-input'
                                                            filter
                                                            showFilterClear
                                                            value={selectedState}
                                                            options={stateLoader == true ? skeletonLength : states}
                                                            itemTemplate={stateItemTemplate}
                                                            onChange={(e) => onChangeStates(e)}
                                                            optionLabel="stateName"
                                                            optionValue="stateId"
                                                            placeholder="State"
                                                        />
                                                        <span className="error-text">{selectedStateError}</span>
                                                    </span>
                                                </div>

                                                <div className="col-lg-6">
                                                    <span className="signup-icon">
                                                        <i className="fa-light fa-city"></i>
                                                        <Dropdown
                                                            className='signup-input'
                                                            filter
                                                            showFilterClear
                                                            value={selectedCity}
                                                            options={cityLoader == true ? skeletonLength : cities}
                                                            onChange={(e) => { setSelectedCityError(''); setSelectedCity(e.target.value) }}
                                                            itemTemplate={cityItemTemplate}
                                                            optionLabel="cityName"
                                                            optionValue="cityId"
                                                            placeholder="City"
                                                        />
                                                        <span className="error-text">{selectedCityError}</span>
                                                    </span>
                                                </div>
                                                <div className="col-lg-6">
                                                    <span className="signup-icon">
                                                        <i className="fa-light fa-file-archive"></i>
                                                        <input value={postalCode} onChange={(e) => { setPostalCodeError(''); setPostalCode(e.target.value) }} className="signup-input" placeholder="Zip/Postal Code" />
                                                        <span className="error-text">{postalCodeError}</span>

                                                    </span>
                                                </div>
                                                <div className="col-lg-6">
                                                    <span className="signup-icon">
                                                        <i className="fa-light fa-phone"></i>
                                                        <InputText keyfilter="int" value={phone} onChange={(e) => { setPhoneError(''); setPhone(e.target.value) }} className="signup-input" placeholder="Phone Number" />
                                                        <span className="error-text">{phoneError}</span>
                                                    </span>
                                                </div>
                                                <div className="col-lg-6">
                                                    <span className="signup-icon">
                                                        <i className="fa-light fa-envelope"></i>
                                                        <input value={email} onChange={(e) => { setEmailError(''); setEmail(e.target.value) }} className="signup-input" placeholder="Email Address" />
                                                        <span className="error-text">{emailError}</span>
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-lg-12 text-center">
                                                    <button onClick={() => onNextContact()} className="signup-btn">
                                                        NEXT <i className="fa-regular fa-chevron-right"></i>
                                                    </button>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="step-side-bar col-lg-3" >
                                <div className="order-summary">
                                    <h2>Order Summary</h2>
                                    <div className="side-bar-content top-content">
                                        <h2 className="summary-heading">Pakage</h2>
                                        <div className="side-bar-content">
                                            <span className="left-content">
                                                Service Type
                                            </span>
                                            <span className="right-content">
                                                Fully Managed Live Chat
                                            </span>
                                        </div>
                                        <div className="side-bar-content">
                                            <span className="left-content">
                                                Pricing Type
                                            </span>
                                            <span className="right-content">
                                                Per Website
                                            </span>
                                        </div>
                                        <div className="side-bar-content">
                                            <span className="left-content">
                                                Setup Charges (One Time charge only)
                                            </span>
                                            <span className="right-content">
                                                USD $0
                                            </span>
                                        </div>
                                    </div>
                                    {selectedAddons?.length > 0 &&
                                        <h2 className="selected-bg-color">Selected Addons</h2>
                                    }
                                    {selectedAddons?.map((x) => {
                                        return <div className="side-bar-content top-content">

                                            <div className="side-bar-content">
                                                <span className="left-content add-on-heading">
                                                    {x?.name}
                                                </span>
                                                <span title="Remove" className="right-content">
                                                    <i onClick={() => onClickRemove(x)} className="fa fa-times clear-btn" />
                                                </span>
                                            </div>

                                            <div className="side-bar-content">
                                                <span className="left-content">
                                                    {x?.setUpTitle}
                                                </span>
                                                <span className="right-content">
                                                    {`USD $${x?.setUpPrice}`}
                                                </span>
                                            </div>
                                            {x?.price !== null && x?.price !== 0 &&
                                                <div className="side-bar-content">
                                                    <span className="left-content">
                                                        {x?.perMonthDescription}
                                                    </span>
                                                    <span className="right-content">
                                                        {`USD $${x?.price}`}
                                                    </span>
                                                </div>
                                            }
                                        </div>

                                    })}

                                    <div className="side-bar-content sidebar-content-white">
                                        <span className="left-content">PAYABLE AMOUNT</span>
                                        <span className="right-content">{`USD $${totalAmount}`}</span>
                                    </div>
                                    <h2> Go The Extra Mile!</h2>
                                    {addOns?.map((e) => {
                                        return <div className="side-bar-content sidebar-pad">
                                            <div className="add-btn-space">
                                                <span className="left-content left-content-head">
                                                    {e?.name}
                                                </span>
                                                <button disabled={isAddDisable(e)} onClick={() => onClickAdd(e)} className="upgrade-btn right-content">
                                                    Add
                                                </button>
                                            </div>
                                            <div>{e?.description}</div>
                                            <div>
                                                <div>
                                                    <span className="left-content">
                                                        {e?.setUpTitle}
                                                    </span>
                                                    <span className="right-content price-usd">
                                                        {`PRICE USD $ ${e?.setUpPrice == null ? 0 : e?.setUpPrice}`}
                                                        {/* {`PRICE USD $ ${e?.setUpPrice}`} */}
                                                    </span>
                                                </div>
                                                {e?.price !== null && e?.price !== 0 &&
                                                    <div>
                                                        <span className="left-content">
                                                            {e?.perMonthDescription}
                                                        </span>
                                                        <span className="right-content price-usd">
                                                            {`PRICE USD $ ${e?.price}`}
                                                        </span>
                                                    </div>
                                                }
                                            </div>

                                        </div>
                                    })}
                                </div>
                            </div>

                        </div>
                    </div>

                </>
            }
            {
                activeIndex == 1 &&
                <>
                    <div className="welcome-wrapper">
                        <div className="row m-0" >
                            <div className="col-lg-9 ">
                                <img className="welcome-page-logo" src={process.env.PUBLIC_URL + "/image/" + DetectEnvironment.config.REACT_APP_LOGO} alt="logo" />
                                <div className="row justify-content-lg-center billing-pad ">
                                    <div className="col-lg-9">
                                        <div className="steps">
                                            <Steps model={items} activeIndex={activeIndex} onSelect={(e) => setActiveIndex(e.index)} readOnly={false} />
                                        </div>
                                        <div className="signup-form-wrapper">
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="label-checkbox-">
                                                        <div className="p-field-checkbox">
                                                            <Checkbox
                                                                inputId="binary"
                                                                checked={isContact}
                                                                onChange={(e) => onChangeUseInfo(e)}
                                                            />
                                                            <label className="lockmsglbl">Use information from step 1 (Contact Information)</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-12">
                                                    <div className="la-heading">
                                                        Billing Information
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <span className="signup-icon">
                                                        <i className="fa-light fa-building"></i>
                                                        <input value={companyNameB} onChange={(e) => { setCompanyNameBErrorB(''); setCompanyNameB(e.target.value) }} className="signup-input" placeholder="Company Name" />
                                                        <span className="error-text">{companyNameErrorB}</span>
                                                    </span>
                                                </div>
                                                <div className="col-lg-6">
                                                    <span className="signup-icon">
                                                        <i className="fa-light fa-user-circle"></i>
                                                        <input value={contactPersonB} onChange={(e) => { setContactPersonBError(''); setContactPersonB(e.target.value) }} className="signup-input" placeholder="Contact Person" />
                                                        <span className="error-text">{contactPersonBError}</span>
                                                    </span>
                                                </div>

                                                <div className="col-lg-6">
                                                    <span className="signup-icon">
                                                        <i className="fa-light fa-user-circle"></i>
                                                        <input value={designationB} onChange={(e) => { setDesignationBError(''); setDesignationB(e.target.value) }} className="signup-input" placeholder="Title Designation" />
                                                        <span className="error-text">{designationBError}</span>
                                                    </span>
                                                </div>

                                                <div className="col-lg-6">
                                                    <span className="signup-icon">
                                                        <i className="fa-light fa-address-card"></i>
                                                        <input value={contactAddressB} onChange={(e) => { setContactAddressBError(''); setContactAddressB(e.target.value) }} className="signup-input" placeholder="Address" />
                                                        <span className="error-text">{contactAddressBError}</span>
                                                    </span>
                                                </div>

                                                <div className="col-lg-6">
                                                    <span className="signup-icon">
                                                        <i className="fa-light fa-globe"></i>
                                                        <Dropdown
                                                            className='signup-input'
                                                            filter
                                                            showFilterClear
                                                            value={selectedCountryB}
                                                            options={countryLoader == true ? skeletonLength : countries}
                                                            onChange={(e) => onChageCountriesB(e)}
                                                            optionLabel="countryName"
                                                            optionValue="countryId"
                                                            placeholder="Country"
                                                        />
                                                        <span className="error-text">{selectedCountryBError}</span>
                                                    </span>
                                                </div>

                                                <div className="col-lg-6">
                                                    <span className="signup-icon">
                                                        <i className="fa-light fa-flag-usa"></i>
                                                        <Dropdown
                                                            className='signup-input'
                                                            filter
                                                            showFilterClear
                                                            value={selectedStateB}
                                                            options={stateLoader == true ? skeletonLength : states}
                                                            onChange={(e) => onChangeStatesB(e)}
                                                            optionLabel="stateName"
                                                            optionValue="stateId"
                                                            placeholder="State"
                                                        />
                                                        <span className="error-text">{selectedStateBError}</span>
                                                    </span>
                                                </div>

                                                <div className="col-lg-6">
                                                    <span className="signup-icon">
                                                        <i className="fa-light fa-city"></i>
                                                        <Dropdown
                                                            className='signup-input'
                                                            filter
                                                            showFilterClear
                                                            value={selectedCityB}
                                                            options={cityLoader == true ? skeletonLength : cities}
                                                            onChange={(e) => { setSelectedCityBError(''); setSelectedCityB(e.target.value) }}
                                                            optionLabel="cityName"
                                                            optionValue="cityId"
                                                            placeholder="City"
                                                        />
                                                        <span className="error-text">{selectedCityBError}</span>
                                                    </span>
                                                </div>
                                                <div className="col-lg-6">
                                                    <span className="signup-icon">
                                                        <i className="fa-light fa-file-archive"></i>
                                                        <input value={postalCodeB} onChange={(e) => { setPostalCodeBError(''); setPostalCodeB(e.target.value) }} className="signup-input" placeholder="Zip/Postal Code" />
                                                        <span className="error-text">{postalCodeBError}</span>
                                                    </span>
                                                </div>


                                                <div className="col-lg-6">
                                                    <span className="signup-icon">
                                                        <i className="fa-light fa-phone"></i>
                                                        <InputText keyfilter="int" value={phoneB} onChange={(e) => { setPhoneBError(''); setPhoneB(e.target.value) }} className="signup-input" placeholder="Phone Number" />
                                                        <span className="error-text">{phoneBError}</span>
                                                    </span>
                                                </div>
                                                <div className="col-lg-6">
                                                    <span className="signup-icon">
                                                        <i className="fa-light fa-envelope"></i>
                                                        <input value={emailB} onChange={(e) => { setEmailBError(''); setEmailB(e.target.value) }} className="signup-input" placeholder="Email Address" />
                                                        <span className="error-text">{emailBError}</span>
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <PaymentForm nameOnCard={(e) => nameHandle(e)}
                                                        cardErrorMsg={cardErrorMsg}
                                                        cardName={nameOnCard}
                                                        cardNumberValue={cardNumber}
                                                        cardExpiriyValue={cardExpiry}
                                                        cardCvv={cvc}
                                                        cardNumber={(e) => { setCardErrorMsg(''); setCardNumber(e) }}
                                                        cardExpiry={(e) => { setCardErrorMsg(''); setCardExpiry(e) }}
                                                        cvc={(e) => { setCardErrorMsg(''); setCvc(e) }}
                                                        isCardInValid={(e) => ChildValidations(e)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-12 text-center">
                                                    <button onClick={() => setActiveIndex(0)} className="signup-btn prev-btn">
                                                        <i className="fa-regular fa-chevron-left"></i> Previous
                                                    </button>
                                                    <button onClick={() => onNextBilling()} className="signup-btn">
                                                        NEXT  <i className="fa-regular fa-chevron-right"></i>
                                                    </button>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="step-side-bar step-side-bar-billing col-lg-3" >
                                <div className="order-summary">
                                    <h2>Order Summary</h2>
                                    <div className="side-bar-content top-content">
                                        <h2 className="summary-heading">Pakage</h2>
                                        <div className="side-bar-content">
                                            <span className="left-content">
                                                Service Type
                                            </span>
                                            <span className="right-content">
                                                Fully Managed Live Chat
                                            </span>
                                        </div>
                                        <div className="side-bar-content">
                                            <span className="left-content">
                                                Pricing Type
                                            </span>
                                            <span className="right-content">
                                                Per Website
                                            </span>
                                        </div>
                                        <div className="side-bar-content">
                                            <span className="left-content">
                                                Setup Charges (One Time charge only)
                                            </span>
                                            <span className="right-content">
                                                USD $0
                                            </span>
                                        </div>
                                    </div>
                                    {selectedAddons?.length > 0 &&
                                        <h2 className="selected-bg-color">Selected Addons</h2>
                                    }
                                    {selectedAddons?.map((x) => {
                                        return <div className="side-bar-content top-content">

                                            <div className="side-bar-content">
                                                <span className="left-content add-on-heading">
                                                    {x?.name}
                                                </span>
                                                <span title="Remove" className="right-content">
                                                    <i onClick={() => onClickRemove(x)} className="fa fa-times clear-btn" />
                                                </span>
                                            </div>

                                            <div className="side-bar-content">
                                                <span className="left-content">
                                                    {x?.setUpTitle}
                                                </span>
                                                <span className="right-content">
                                                    {`USD $${x?.setUpPrice}`}
                                                </span>
                                            </div>
                                            {x?.price !== null && x?.price !== 0 &&
                                                <div className="side-bar-content">
                                                    <span className="left-content">
                                                        {x?.perMonthDescription}
                                                    </span>
                                                    <span className="right-content">
                                                        {`USD $${x?.price}`}
                                                    </span>
                                                </div>
                                            }
                                        </div>

                                    })}

                                    <div className="side-bar-content sidebar-content-white">
                                        <span className="left-content">PAYABLE AMOUNT</span>
                                        <span className="right-content">{`USD $${totalAmount}`}</span>
                                    </div>
                                    <h2> Go The Extra Mile!</h2>
                                    {addOns?.map((e) => {
                                        return <div className="side-bar-content sidebar-pad">
                                            <div className="add-btn-space">
                                                <span className="left-content left-content-head">
                                                    {e?.name}
                                                </span>
                                                <button disabled={isAddDisable(e)} onClick={() => onClickAdd(e)} className="upgrade-btn right-content">
                                                    Add
                                                </button>
                                            </div>
                                            <div>{e?.description}</div>
                                            <div>
                                                <div>
                                                    <span className="left-content">
                                                        {e?.setUpTitle}
                                                    </span>
                                                    <span className="right-content price-usd">
                                                        {`PRICE USD $ ${e?.setUpPrice}`}
                                                    </span>
                                                </div>
                                                {e?.price !== null && e?.price !== 0 &&
                                                    <div>
                                                        <span className="left-content">
                                                            {e?.perMonthDescription}
                                                        </span>
                                                        <span className="right-content price-usd">
                                                            {`PRICE USD $ ${e?.price}`}
                                                        </span>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>

                </>
            }

            {
                activeIndex == 2 &&
                <>
                    <div className="welcome-wrapper">
                        <div className="row" >
                            <div className="col-lg-9 pb-5">
                                <img className="welcome-page-logo" src={process.env.PUBLIC_URL + "/image/" + DetectEnvironment.config.REACT_APP_LOGO} alt="logo" />
                                <div className="row justify-content-lg-center">
                                    <div className="col-lg-9">
                                        <div className="steps">
                                            <Steps model={items} activeIndex={activeIndex} onSelect={(e) => setActiveIndex(e.index)} readOnly={false} />
                                        </div>
                                        <div className="signup-form-wrapper">
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="la-heading">
                                                        Order Summary
                                                    </div>
                                                </div>
                                                <div className="col-lg-12">
                                                    <div className="la-heading la-heading-2">
                                                        Pakage Details:
                                                    </div>
                                                </div>
                                                <div className="col-lg-12">
                                                    <div className="summary-text">
                                                        <span className="summary-text-left">
                                                            Service Type
                                                        </span>
                                                        <span className="summary-text-right">
                                                            Fully Managed Live Chat
                                                        </span>
                                                    </div>
                                                    <div className="summary-text">
                                                        <span className="summary-text-left">
                                                            Pricing Type
                                                        </span>
                                                        <span className="summary-text-right">
                                                            Per Website
                                                        </span>
                                                    </div>
                                                    <div className="summary-text">
                                                        <span className="summary-text-left">
                                                            Setup Charges (One Time charge only)
                                                        </span>
                                                        <span className="summary-text-right">
                                                            $0
                                                        </span>
                                                    </div>
                                                    {selectedAddons?.length > 0 &&
                                                        <div className="col-lg-12">
                                                            <div className="la-heading la-heading-2">
                                                                Selected Addons:
                                                            </div>
                                                        </div>
                                                    }
                                                    {selectedAddons?.map((x) => {
                                                        return <>
                                                            <div className="summary-text">
                                                                <span style={{ fontWeight: 'bold' }} className="summary-text-left">
                                                                    {x?.name}
                                                                </span>
                                                                <span title="Remove" className="summary-text-right">
                                                                    <i onClick={() => onClickRemove(x)} className="fa fa-times clear-btn" />
                                                                </span>
                                                            </div>
                                                            <div className="summary-text">
                                                                <div>
                                                                    <span className="summary-text-left">
                                                                        {x?.setUpTitle}
                                                                    </span>
                                                                    <span className="summary-text-right">
                                                                        {`PRICE USD $ ${x?.setUpPrice}`}
                                                                    </span>
                                                                </div>
                                                                {x?.price !== null && x?.price !== 0 &&
                                                                    <div>
                                                                        <span className="summary-text-left">
                                                                            {x?.perMonthDescription}
                                                                        </span>
                                                                        <span className="summary-text-right">
                                                                            {`PRICE USD $ ${x?.price}`}
                                                                        </span>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </>
                                                    })}

                                                    <div className="summary-text total-price">
                                                        <span className="summary-text-left">
                                                            Total Payable
                                                        </span>
                                                        <span className="summary-text-right">
                                                            {`$${totalAmount}`}
                                                        </span>
                                                    </div>
                                                    <div className="label-checkbox">
                                                        <div className="p-field-checkbox">
                                                            <Checkbox
                                                                inputId="binary"
                                                                checked={isAggreed}
                                                                onChange={(e) => setIsAggreed(e.checked)}
                                                            />
                                                            <label className="lockmsglbl">I authorize LiveAdmins to charge all credit card indicated in this authorization form according to terms out-lined above. This payment authorization is for goods/services described above for amount indicated above only. I certify that I am authorized user of this credit card and that I will not dispute the payment with my credit card company, so long as the transaction corresponds to terms indicated in this agreement.</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-12 text-center">
                                                    <button onClick={() => setActiveIndex(1)} className="signup-btn prev-btn">
                                                        <i className="fa-regular fa-chevron-left"></i> Previous
                                                    </button>
                                                    <button onClick={() => CheckOut()} className="signup-btn">
                                                        PROCEED TO CHECKOUT
                                                    </button>

                                                    <div className="la-heading need-assitance">
                                                        Need assistance? Cal us now at (877) 771 6067
                                                    </div>

                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="right-bar col-lg-3">

                            </div>

                        </div>
                    </div>
                </>
            }
        </div>
    )
}
export default BillingInformation;